import React from "react";
import { Box } from "@mantine/core";
import WizardProgressBar from "./WizardProgressBar";
import styles from "./AccountCreationLayout.module.css";
import pagodaBackground from "../pagoda_logo_onboarding_background.png";

interface AccountCreationLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  hideStepper?: boolean;
  /**
   * Optional right-aligned header content (e.g. the multi-location
   * "Switch location" escape hatch — the onboarding redirect is not a hard
   * gate, see DESIGN_DELTA_2026-07-23 §4).
   */
  headerRight?: React.ReactNode;
}

export default function AccountCreationLayout({
  children,
  currentStep,
  totalSteps,
  hideStepper = false,
  headerRight,
}: AccountCreationLayoutProps) {
  return (
    <div className={styles.shell}>
      {/* Background illustration - spans full viewport */}
      <img
        src={pagodaBackground}
        alt=""
        className={styles.backgroundImage}
        aria-hidden="true"
      />

      {/* Top row - Logo (centered container) */}
      <header className={styles.header}>
        <img
          src="/images/pagoda-logo-horizontal.png"
          alt="Pagoda"
          className={styles.logo}
        />
        {headerRight && <Box ml="auto">{headerRight}</Box>}
      </header>

      {/* Middle section - centered content */}
      <div className={styles.mainSection}>
        <div className={styles.contentContainer}>
          <div className={styles.contentColumn}>
            {/* Progress bar - hide on dashboard view */}
            {!hideStepper && (
              <div className={styles.progressContainer}>
                <WizardProgressBar
                  currentStep={currentStep}
                  totalSteps={totalSteps}
                />
              </div>
            )}

            {/* Main content area */}
            <main className={styles.content}>{children}</main>
          </div>
        </div>
      </div>

      {/* Bottom row - Footer (centered container) */}
      <footer className={styles.footer}>
        <div className={styles.footerLeft}>
          <span className={styles.copyright}>
            © Copyright {new Date().getFullYear()}, Pagoda Labs, Inc.
          </span>
        </div>
        <div className={styles.footerRight}>
          <a
            href="https://www.getpagoda.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            Privacy Policy
          </a>
          <a
            href="https://www.getpagoda.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            Terms of Service
          </a>
        </div>
      </footer>
    </div>
  );
}
